import React, { useEffect } from 'react';
import Select from '../bootstrap/forms/Select';
import { useOrganization } from '../../contexts/organizationContext';
import { useTranslation } from 'react-i18next';
import Icon from '../icon/Icon';
import { useLocation, useNavigate } from 'react-router-dom';

const OrganizationDropdown = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();
	const {
		selectedOrganization,
		setSelectedOrganization,
		organizations,
		isLoading,
		fetchOrganizations,
	} = useOrganization();

	useEffect(() => {
		// Always call fetchOrganizations on mount
		// The context implementation will prevent redundant API calls
		fetchOrganizations().catch((error) => {
			console.error('Error fetching organizations:', error);
		});
	}, [fetchOrganizations]);

	const handleOrganizationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOrg = organizations.find((org) => org.id === e.target.value);

		// Set the selected organization in context
		setSelectedOrganization(selectedOrg || null);

		// If we're on an organization-specific page, navigate to the corresponding page for the new org
		const currentPath = location.pathname;

		if (selectedOrg) {
			// Handle organization detail view
			if (currentPath.match(/\/company\/organizations\/[\w-]+$/)) {
				navigate(`/company/organizations/${selectedOrg.id}`);
			}
			// Handle organization edit view
			else if (currentPath.match(/\/company\/organizations\/edit\/[\w-]+$/)) {
				navigate(`/company/organizations/edit/${selectedOrg.id}`);
			}
		}
	};

	return (
		<div className='d-flex align-items-center'>
			<Icon icon='Business' className='me-2' size='lg' color='primary' />
			<Select
				id='organization-select'
				ariaLabel={t('Select Organization')}
				value={selectedOrganization?.id || ''}
				onChange={handleOrganizationChange}
				className='border-0 bg-transparent fw-bold text-primary'
				style={{
					minWidth: '150px',
					border: 'none',
					outline: 'none',
					boxShadow: 'none',
				}}>
				<option value='' disabled>
					{isLoading ? `${t('Loading')}...` : t('Select Organization')}
				</option>
				{organizations.map((org) => (
					<option key={org.id} value={org.id}>
						{org.name}
					</option>
				))}
			</Select>
		</div>
	);
};

export default OrganizationDropdown;
